import { render, staticRenderFns } from "./out-header.vue?vue&type=template&id=a5ab8b5e&scoped=true&"
import script from "./out-header.vue?vue&type=script&lang=js&"
export * from "./out-header.vue?vue&type=script&lang=js&"
import style0 from "./out-header.vue?vue&type=style&index=0&id=a5ab8b5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ab8b5e",
  null
  
)

export default component.exports